import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | error

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setState("error"); return; }
      } catch (e) {}
      if (tries++ < 8) setTimeout(poll, 2000);
      else setState("error");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-8">
      <div className="w-full max-w-md border border-border bg-card p-10 text-center animate-fade-up">
        {state === "checking" && (
          <>
            <Loader2 size={48} className="mx-auto mb-4 animate-spin text-primary" />
            <h1 className="font-display text-2xl font-bold">Vérification du paiement…</h1>
            <p className="mt-2 text-sm text-muted-foreground">Merci de patienter quelques instants.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={48} className="mx-auto mb-4 text-emerald-400" />
            <h1 className="font-display text-2xl font-bold">Paiement réussi</h1>
            <p className="mt-2 text-sm text-muted-foreground">La facture a été marquée comme payée.</p>
            <button onClick={() => navigate("/facturation")} data-testid="back-to-invoices" className="mt-6 bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90">
              Retour aux factures
            </button>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle size={48} className="mx-auto mb-4 text-destructive" />
            <h1 className="font-display text-2xl font-bold">Paiement non confirmé</h1>
            <p className="mt-2 text-sm text-muted-foreground">Le paiement n'a pas pu être vérifié. Réessayez depuis la facture.</p>
            <button onClick={() => navigate("/facturation")} className="mt-6 border border-border px-5 py-2.5 text-sm transition-colors hover:bg-accent">
              Retour aux factures
            </button>
          </>
        )}
      </div>
    </div>
  );
}
